import { render, staticRenderFns } from "./QueryLogsTable.vue?vue&type=template&id=9cc9a546&scoped=true&"
import script from "./QueryLogsTable.vue?vue&type=script&lang=js&"
export * from "./QueryLogsTable.vue?vue&type=script&lang=js&"
import style0 from "./QueryLogsTable.vue?vue&type=style&index=0&id=9cc9a546&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cc9a546",
  null
  
)

export default component.exports